import React, {useState } from 'react'
import { Button, Dialog, Pane, toaster} from 'evergreen-ui';
import Cookies from 'js-cookie';
import { gql, useMutation, } from '@apollo/client';

export const SET_BANK_AS_DEFAULT = gql`
mutation FacilityManager_makeBankAccountPrimary($bankAccountId: ID!) {
  facilityManager_makeBankAccountPrimary(bankAccountId: $bankAccountId) {
    code
    success
    error
    token
  }
}
`;




const SetBankAsDeafultButton = (props) => {
const id = props.id;
const accesTokenValue = Cookies.get('userAccessToken');
const [ setBankAsDefault, {loading}] = useMutation(SET_BANK_AS_DEFAULT);
const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

const handleSubmit = (e)=>{
  e.preventDefault()
  console.log("dskjc")
  setBankAsDefault({
    variables: { 
      bankAccountId: id,
    },
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  }).then((response) => {
    toaster.success("Bank set as default")
    window.location.reload()
  })
  .catch((error) => {
    toaster.danger(error.message)
  });

}


  return (
    <div>
      
      <Pane>
        <Dialog
          isShown={isDialogOpen}
          title="Set as default"
          shouldCloseOnEscapePress={false}
          shouldCloseOnOverlayClick={false}
          hasFooter={false}
        >
          Are you sure you want to set this bank as deafult?
          <br/>
          <br/>
          <div className='row right' 
            style={{
                display:"flex",
                flexWrap:"wrap"
            }}
          >
                <Button  >
                    Cancel
                </Button>
                <span style={{
                    width:"10px"
                }}></span>
                <Button  
                 appearance="primary" 
                 onClick={handleSubmit}
                 loading={loading}
                >
                    Procced
                </Button>
          </div>
        </Dialog>
           <span onClick={handleOpenDialog}
            style={{
              // background:"red",
              height:"40px",
              paddingTop:"9px",
              cursor:"pointer",
              color:"#4F46E5"
            }} >Set as default</span>
      </Pane>
    </div>
  );
};

export default SetBankAsDeafultButton;
